var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c("div", [_c("strong", [_vm._v(_vm._s(_vm.record.projectTitle))])]),
      _vm._v(" "),
      _vm._l(_vm.record, function (t) {
        return _c("div", { staticClass: "change_block" }, [
          _c("div", [
            _c(
              "span",
              {
                class: {
                  "btn btn-outline-primary": true,
                  active: +t.task.is_active,
                },
              },
              [_vm._v("A")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: {
                  "btn btn-outline-primary": true,
                  active: +t.task.order_allow,
                },
              },
              [_vm._v("З")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "price_span" }, [
              _vm._v("кол. "),
              _c("strong", [_vm._v(_vm._s(t.task.qty))]),
              _vm._v(": "),
              _c("strong", [_vm._v(_vm._s(t.task.price))]),
              _vm._v("\n              (" + _vm._s(t.profitTask) + "%)\n    "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "actual_data" }, [
            _c(
              "span",
              {
                class: {
                  "btn btn-outline-primary": true,
                  active: +t.actualData.is_active,
                },
              },
              [_vm._v("A")]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                class: {
                  "btn btn-outline-primary": true,
                  active: +t.actualData.order_allow,
                },
              },
              [_vm._v("З")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "price_span" }, [
              _vm._v("кол. "),
              _c("strong", [_vm._v(_vm._s(t.actualData.qty))]),
              _vm._v(": "),
              _c("strong", [_vm._v(_vm._s(t.actualData.price))]),
              _vm._v("\n              (" + _vm._s(t.profitActual) + "%)\n    "),
            ]),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }